var map = {
	"./Algeria-DZ.svg": [
		95251,
		5251
	],
	"./Angola-AO.svg": [
		15890,
		5890
	],
	"./Argentina-AR.svg": [
		94447,
		4447
	],
	"./Australia-AU.svg": [
		32398,
		2398
	],
	"./Austria-AT.svg": [
		89816,
		9816
	],
	"./Azerbaijan-AZ.svg": [
		56772,
		6772
	],
	"./Bahrain-BH.svg": [
		39468,
		9468
	],
	"./Bangladesh-BD.svg": [
		73073,
		3073
	],
	"./Belarus-BY.svg": [
		27348,
		7348
	],
	"./Belgium-BE.svg": [
		64308,
		4308
	],
	"./Bolivia-BO.svg": [
		27120,
		7120
	],
	"./Brazil-BR.svg": [
		20788,
		788
	],
	"./Bulgaria-BG.svg": [
		79799,
		9799
	],
	"./Cambodia-KH.svg": [
		38799,
		8799
	],
	"./Cameroon-CM.svg": [
		62079,
		2079
	],
	"./Canada-CA.svg": [
		23431,
		3431
	],
	"./Chile-CL.svg": [
		80752,
		752
	],
	"./China-CN.svg": [
		49619,
		9619
	],
	"./Colombia-CO.svg": [
		74419,
		8853
	],
	"./Costa-Rica-CR.svg": [
		67011,
		7011
	],
	"./Cote-d'Ivori-CI.svg": [
		62095,
		2095
	],
	"./Croatia-HR.svg": [
		91067,
		1067
	],
	"./Czech-Republic-CZ.svg": [
		74993,
		4993
	],
	"./Denmark-DK.svg": [
		67082,
		7082
	],
	"./Dominican-Republic-DO.svg": [
		69415,
		9415
	],
	"./Ecuador-EC.svg": [
		63940,
		3940
	],
	"./Egypt-EG.svg": [
		57565,
		7565
	],
	"./El-Salvador-SV.svg": [
		8239,
		8239
	],
	"./Eritrea-ER.svg": [
		45466,
		5466
	],
	"./Estonia-EE.svg": [
		71935,
		1935
	],
	"./European-Union-EU.svg": [
		76327,
		6327
	],
	"./Finland-FI.svg": [
		30163,
		163
	],
	"./France-FR.svg": [
		93619,
		3619
	],
	"./France-britain-split.svg": [
		4147,
		4147
	],
	"./Gabon-GA.svg": [
		80464,
		464
	],
	"./Georgia-GE.svg": [
		4868,
		4868
	],
	"./Germany-DE.svg": [
		79066,
		9066
	],
	"./Greece-GR.svg": [
		70098,
		98
	],
	"./Greenland-GL.svg": [
		14736,
		4736
	],
	"./Guadeolupe-GP.svg": [
		14408,
		4408
	],
	"./Guatemala-GT.svg": [
		84823,
		4823
	],
	"./Honduras-HN.svg": [
		10593,
		593
	],
	"./Hong-Kong-HK.svg": [
		58357,
		8357
	],
	"./Hungary-HU.svg": [
		92887,
		2887
	],
	"./India-IN.svg": [
		8000,
		8000
	],
	"./Indonesia-ID.svg": [
		22603,
		5952
	],
	"./Iran-IR.svg": [
		25220,
		5220
	],
	"./Iraq-IQ.svg": [
		34613,
		4613
	],
	"./Ireland-IE.svg": [
		68481,
		8481
	],
	"./Israel-IL.svg": [
		23037,
		3037
	],
	"./Italy-IT.svg": [
		93594,
		3594
	],
	"./Japan-JP.svg": [
		31554,
		1554
	],
	"./Jordan-JO.svg": [
		59531,
		9531
	],
	"./Kazakhstan-KZ.svg": [
		91,
		91
	],
	"./Kenya-KE.svg": [
		4289,
		4289
	],
	"./Kuwait-KW.svg": [
		35780,
		5780
	],
	"./Kyrgystan-KG.svg": [
		33097,
		3097
	],
	"./Libya-LY.svg": [
		16308,
		6308
	],
	"./Luxembourg-LU.svg": [
		68756,
		8756
	],
	"./Malaysia-MY.svg": [
		76941,
		6941
	],
	"./Malta-MT.svg": [
		65119,
		5119
	],
	"./Martinique-MQ.svg": [
		97463,
		7463
	],
	"./Mexico-MX.svg": [
		59532,
		9532
	],
	"./Morroco-MA.svg": [
		71600,
		1600
	],
	"./Mozambique-MZ.svg": [
		74050,
		4050
	],
	"./Netherlands-NL.svg": [
		41684,
		1684
	],
	"./New-Zealand-NZ.svg": [
		10361,
		361
	],
	"./Nigeria-NG.svg": [
		14135,
		4135
	],
	"./Norway-NO.svg": [
		7016,
		7016
	],
	"./Oman-OM.svg": [
		52730,
		2730
	],
	"./Pakistan-PK.svg": [
		14728,
		4728
	],
	"./Palestine-PS.svg": [
		67741,
		7741
	],
	"./Panama-PA.svg": [
		50392,
		7787
	],
	"./Peru-PE.svg": [
		40094,
		94
	],
	"./Philippines-PH.svg": [
		31431,
		1431
	],
	"./Poland-PL.svg": [
		24063,
		4063
	],
	"./Portugal-PT.svg": [
		26564,
		6564
	],
	"./Puerto-Rico-PR.svg": [
		26442,
		6442
	],
	"./Qatar-QA.svg": [
		53017,
		3017
	],
	"./Rainbow.svg": [
		17913,
		7913
	],
	"./Reunion-RE.svg": [
		34198,
		4198
	],
	"./Romania-RO.svg": [
		7564,
		7564
	],
	"./Russia-RU.svg": [
		88717,
		8717
	],
	"./Saudi-Arabia-SA.svg": [
		24997,
		4997
	],
	"./Senegal-SN.svg": [
		88684,
		8684
	],
	"./Serbia-RS.svg": [
		68929,
		8929
	],
	"./Singapore-SG.svg": [
		45650,
		5650
	],
	"./Slovakia-SK.svg": [
		48979,
		8979
	],
	"./Slovenia-SI.svg": [
		61702,
		1702
	],
	"./South-Africa-ZA.svg": [
		5080,
		5080
	],
	"./South-Korea-KR.svg": [
		14657,
		4657
	],
	"./Spain-ES.svg": [
		76944,
		6944
	],
	"./Sudan-SD.svg": [
		17117,
		7117
	],
	"./Sweden-SE.svg": [
		25569,
		5569
	],
	"./Switzerland-CH.svg": [
		50141,
		141
	],
	"./Syria-SY.svg": [
		90148,
		148
	],
	"./Taiwan-TW.svg": [
		95793,
		5793
	],
	"./Thailand-TH.svg": [
		65115,
		5115
	],
	"./Tunisia-TN.svg": [
		58157,
		8157
	],
	"./Turkey-TR.svg": [
		4768,
		4768
	],
	"./Ukraine-UA.svg": [
		47233,
		7233
	],
	"./United-Arab-Emirates-AE.svg": [
		89518,
		9518
	],
	"./United-Kingdom-GB.svg": [
		15173,
		5173
	],
	"./United-States-US.svg": [
		51197,
		7397
	],
	"./Uruguay-UY.svg": [
		95880,
		5880
	],
	"./Uzbekistan-UZ.svg": [
		67375,
		7375
	],
	"./Venezuela-VE.svg": [
		91993,
		1993
	],
	"./Vietnam-VN.svg": [
		27682,
		7682
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 53520;
module.exports = webpackAsyncContext;